import debounce from 'lodash/debounce';
import { useCallback, useLayoutEffect, useRef, useState } from 'react';

import { aperture } from '@/home/views/module/Wrapper/helpers';

function useAperture(elementSize) {
    // container which width is used to calculate size of group
    const containerRef = useRef();
    // size of group
    const [size, setSize] = useState(0);
    // rest in pixels after all items of elementSize are in group
    const [rest, setRest] = useState(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const apertureFn = useCallback(aperture(size), [size]);
    useLayoutEffect(() => {
        function changeSize() {
            if (containerRef.current) {
                const clientWidth = containerRef.current.clientWidth;
                if (clientWidth && elementSize > clientWidth) {
                    console.error(
                        `useAperture: Element size (${elementSize}px) is bigger than container width (${clientWidth}px).`
                    );
                }
                setSize(Math.floor(clientWidth / elementSize));
                setRest(clientWidth - size * elementSize);
            }
        }
        // init
        changeSize();
        // listener
        const resizeListener = debounce(changeSize, 100);
        // todo: re-implement with resize observer once it is supported in edge
        window.addEventListener('resize', resizeListener);
        // cleanup
        return () => window.removeEventListener('resize', resizeListener);
    });
    return [containerRef, apertureFn, rest, size];
}

export default useAperture;
